import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

import { getCurrentIp as fetchCurrentIp } from '@/api/common';
import { isProduction, setCookie } from '@/helpers/common';
import { Country } from '@/helpers/conf';
import { DOMAINS, WHITELIST_IPS } from '@/helpers/constants';
import { FeatureEnum } from '@/helpers/feature';
import { isCountryNotAllowed } from '@/helpers/locale';
import { SEARCH_ENGINES } from '@/helpers/seo';
import { USER_IP } from '@/helpers/variables';
import { STORAGE, useCommonStore, useLocalStorageStore } from '@/store';

export function useClientLocale() {
  const [isServiceBlocked, setServiceBlocked] = useState<boolean | null>(null);

  const { push } = useRouter();

  useEffect(() => {
    const initialize = async () => {
      const isSearchEngine = SEARCH_ENGINES.some((str) =>
        document.referrer.includes(str)
      );

      if (isSearchEngine) {
        useLocalStorageStore.getState().push(STORAGE.IS_SEARCH_ENGINE, true);
      }
      try {
        const { data } = await fetchCurrentIp();

        if (!data) return;
        const { countryCode, ip } = data;

        const isWhitelistIP = WHITELIST_IPS.includes(ip);
        if (isCountryNotAllowed(countryCode, ip) && !isWhitelistIP) {
          setServiceBlocked(true);
          return;
        }

        const isEERedirect = useLocalStorageStore
          .getState()
          .get(STORAGE.FEATURE_IS_EE_REDIRECT);

        if (
          isProduction() &&
          [Country.Estonia, Country.Finland].includes(countryCode as Country) &&
          window.location.hostname !== DOMAINS.MAIN &&
          isEERedirect === FeatureEnum.ON
        ) {
          push('https://levelupcasino.com/');
          return;
        }

        useCommonStore.setState({ countryCode });
        setCookie(USER_IP, ip);
        setServiceBlocked(false);
      } catch (error) {
        console.log(error);
      }
    };

    initialize();
  }, [push]);

  return { isServiceBlocked, isLoading: isServiceBlocked === null };
}
